import { ReleaseResponse, TuneCoreRelease } from 'types/releases';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getReleaseLink } from 'app/store/Releases/selectors';
import { addAlertAction } from 'app/store/Alerts/slice';
import { useFetch } from 'app/utils/hooks';

export const useFetchTuneCoreUrl = (releaseGuid: string) => {
  const dispatch = useAppDispatch();
  const releaseLink = useAppSelector(getReleaseLink);
  const [loading, setLoading] = useState(false);
  const { callAPI } = useFetch<{}, ReleaseResponse>();

  const dispatchErrorMsg = () =>
    dispatch(
      addAlertAction({
        message: "Couldn't find TuneCore link, please try again",
      })
    );

  const fetchTuneCoreUrl = async () => {
    try {
      setLoading(true);
      const { response } = await callAPI(
        (releaseLink?.href || '').replace('{releaseGuid}', releaseGuid)
      );
      const releaseItem = response.release.item as TuneCoreRelease;
      const { tuneCoreReleaseUrl } =
        releaseItem.latestExport?.tuneCore?.callbackResponse || {};

      if (!tuneCoreReleaseUrl) {
        dispatchErrorMsg();
      }

      return tuneCoreReleaseUrl;
    } catch (e) {
      dispatchErrorMsg();
    } finally {
      setLoading(false);
    }
    return undefined;
  };

  return {
    fetchTuneCoreUrl,
    loading,
  };
};
